module.exports = __webpack_public_path__ + "90473696d20ba1478721511e33cfb2ff.png";